var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLatest({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "16px",
    viewBox: "0 0 18.0 16.0",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "i0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.00003258,0 C10.2092057,0 12.2088589,0.895696704 13.6564393,2.34356067 L15.3391823,0.660817703 C15.5830394,0.416960629 16,0.589686161 16,0.934538685 L16,5.54838635 C16,5.762159 15.8266759,5.93548307 15.6129033,5.93548307 L10.9990556,5.93548307 C10.6542031,5.93548307 10.4814776,5.51855395 10.7253661,5.27466537 L12.4714281,3.52857185 C11.3276531,2.38460779 9.74719716,1.67741913 8,1.67741913 C4.50523088,1.67741913 1.67742128,4.50576426 1.67742128,8 C1.67742128,11.4947691 4.50576642,14.3225787 8,14.3225787 C9.6163063,14.3225787 11.0899074,13.7176141 12.2071263,12.7215835 C12.360289,12.5850222 12.5943175,12.5942838 12.7394158,12.7393821 L13.3761344,13.3761008 C13.5332665,13.5332643 13.525517,13.7894702 13.3605724,13.9384432 C11.9420053,15.2197875 10.0621228,16 8,16 C3.58370253,16 0.00321535761,12.4215268 0,8.0059528 C-0.00321105281,3.59759276 3.59160953,0 8.00003258,0 Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "i1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.80330911,0.0958493363 C6.93429289,-0.0326722358 7.1458026,-0.0318387277 7.27572611,0.0977045641 L7.90310523,0.723185178 C8.03302874,0.852728469 8.03218597,1.061939 7.90122938,1.19046058 L3.09656066,5.904164 C2.96557688,6.03268557 2.75406717,6.03182518 2.62414366,5.90228189 L0.0969016684,3.38261378 C-0.0330490278,3.2530436 -0.032179065,3.04383306 0.098804712,2.91533838 L0.731267682,2.29485881 C0.862251459,2.16636413 1.07376117,2.16722452 1.20368468,2.29676782 L2.8682226,3.95636311 Z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.0 -2.0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(3.552713678800501e-15 -0.19774071464894405)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(3.8707503295947063 19.395481429297888) rotate(-104.00000000000001)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i0)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "-2.14951836e-06,-4.54747351e-13 16,-4.54747351e-13 16,16 -2.14951836e-06,16 -2.14951836e-06,-4.54747351e-13",
    stroke: "none",
    fill: "#74AE43"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(6.0 7.0)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i1)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "9.71445147e-17,1.52655666e-16 8,1.52655666e-16 8,6 9.71445147e-17,6 9.71445147e-17,1.52655666e-16",
    stroke: "none",
    fill: "#74AE43"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLatest);
export default __webpack_public_path__ + "static/media/latest.30c7113f984e7a98923b0b3cf386797f.svg";
export { ForwardRef as ReactComponent };